import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './NotInTheLocationAttendanceReport.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import {
    getDistrict,
    getProject,
    getStates,
    getEmployeSatateAndDistrictWise,
    gettingAttendaceEmployeeWise,
    gettingAttendaceEmployeeWiseNotInTheLocation,
    gettingAttendaceEmployeeWiseNotInTheLocationEmployeePhoto,
    gettingAttendanceDistrictViolationsSummary,
    gettingAttendaceEmployeeWiseNotInLocationPhoto,
    getDistrictByZoneId
} from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter, convertToIST } from '../../../utils/validations';
import { format } from 'date-fns';
import { saveAs } from 'file-saver';

const NotInTheLocationAttendanceReport = () => {
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [employeeOptions, setEmployeeoptions] = useState([]);
    const [employee, setemployee] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [attendanceData, setAttendanceData] = useState([]);
    const [employeeAttendanceData, setEmployeeAttendanceData] = useState([]);

    const [drilldownData, setDrilldownData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [isDrilldownLoading, setIsDrilldownLoading] = useState(false);
    const [showDrilldown, setShowDrilldown] = useState(false);
    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        employee: false,
        fromDate: false,
        toDate: false,
    });
    const [errors, setErrors] = useState({});
    const yearInputRef = useRef(null);
    const [designationData, setDesignationData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const isFetchDataEnabled = state && fromDate && toDate;
    const [isLoading, setIsLoading] = useState(false);

    const [districtSummaryData, setDistrictSummaryData] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [isDistrictSummaryLoading, setIsDistrictSummaryLoading] = useState(false);
    const [showDistrictSummary, setShowDistrictSummary] = useState(false);

    // Track API response message for PDF/Excel exports
    const [responseMessage, setResponseMessage] = useState('');

    // Track the current view state
    const [currentView, setCurrentView] = useState('main');
    const [selectedStateData, setSelectedStateData] = useState(null);
    const [selectedDistrictData, setSelectedDistrictData] = useState(null);
    const [totalEmployeeCount, setTotalEmployeeCount] = useState(0);
    const [selectedEmployeeData, setSelectedEmployeeData] = useState(null);

    // Refs for tables
    const mainTableRef = useRef(null);
    const districtSummaryTableRef = useRef(null);
    const drilldownTableRef = useRef(null);
    const employeeTableRef = useRef(null);

    const zoneId = localStorage.getItem("zoneId");
    const zoneName = localStorage.getItem("zoneName");
    const userRole = localStorage.getItem("role");
    const itmDistrictName = localStorage.getItem("districtName");
    const itmDistrictId = localStorage.getItem("districtId");
    const isITM = userRole === "ITM" || userRole === "itm";
    const isPM = userRole === "PM" || userRole === 'pm';

    const getWorkLocation = (row) => {
        return row.workLocationName || row.godownName || '-';
    };

    const getReportTime = () => {
        return format(new Date(), 'dd-MM-yyyy HH:mm:ss');
    };

    const handleClearAll = () => {
        setDistrict(null);
        setemployee(null);
        setFromDate(null);
        setToDate(null);
        setAttendanceData([]);
        setEmployeeAttendanceData([]);
        setHasFetched(false);
        setErrors({});
        setResponseMessage('');
        handleBackToMainTable();
    };

    useEffect(() => {
        const fetchStates = async () => {
            try {
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        };
    }, []);

    useEffect(() => {
        const fetchDistricts = async () => {
            try {
                let districtsData;

                if (isITM && itmDistrictId) {
                    if (state) {
                        districtsData = await getDistrict(state);
                    } else {
                        setDistrictOptions([]);
                        setDistrict(null);
                        return;
                    }

                    const filteredDistricts = districtsData.filter(
                        item => String(item.districtId) === String(itmDistrictId)
                    );

                    setDistrictOptions(
                        filteredDistricts.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );

                    if (filteredDistricts.length > 0) {
                        setDistrict(filteredDistricts[0].districtId);
                    } else {
                        setDistrictOptions([]);
                        setDistrict(null);
                        setErrors(prev => ({
                            ...prev,
                            general: 'Your assigned district could not be found'
                        }));
                    }
                    return;
                }

                if (isPM) {
                    if (state) {
                        districtsData = await getDistrict(state);
                        setDistrictOptions(
                            districtsData.map(item => ({
                                value: item.districtId,
                                label: item.districtName,
                            }))
                        );
                        setDistrict(null);
                    } else {
                        setDistrictOptions([]);
                        setDistrict(null);
                    }
                    return;
                }

                const hasValidZoneId = zoneId && zoneId !== 'null' && zoneId !== '' && zoneId !== 'undefined';

                if (hasValidZoneId) {
                    const response = await getDistrictByZoneId(zoneId);
                    districtsData = response.districts || [];
                } else if (state) {
                    districtsData = await getDistrict(state);
                } else {
                    setDistrictOptions([]);
                    setDistrict(null);
                    return;
                }

                setDistrictOptions(
                    districtsData.map(item => ({
                        value: item.districtId,
                        label: item.districtName,
                    }))
                );
                setDistrict(null);

            } catch (error) {
                console.error('Error fetching districts:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
            }
        };

        fetchDistricts();
    }, [state, zoneId, isITM, itmDistrictId, isPM]);

    useEffect(() => {
        if (district) {
            const fetchingEmployees = async () => {
                try {
                    const data = await getEmployeSatateAndDistrictWise(state, district);
                    setEmployeeoptions(
                        data.map(emp => ({
                            value: emp.employeeUniqueId,
                            label: `${emp.employeeName} -${emp.contactNumber} - ${emp.designation}`,
                        }))
                    );
                } catch (error) {
                    console.log("District or state missing", error);
                }
            };
            fetchingEmployees();
        } else {
            setEmployeeoptions([]);
            setemployee(null);
        }
    }, [district, state]);

    useEffect(() => {
        setAttendanceData([]);
        setEmployeeAttendanceData([]);
        setHasFetched(false);
        setResponseMessage('');
        handleBackToMainTable();
    }, [state, district, fromDate, toDate, employee]);

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setemployee(null);
                break;
            case 'district':
                if (!isITM) {
                    setDistrict(value);
                    setemployee(null);
                }
                break;
            case 'employee':
                setemployee(value);
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            setIsLoading(true);
            setHasFetched(true);
            setAttendanceData([]);
            setEmployeeAttendanceData([]);
            handleBackToMainTable();

            if (employee) {
                const data = await gettingAttendaceEmployeeWiseNotInLocationPhoto(
                    state,
                    district,
                    employee,
                    fromDate,
                    toDate
                );

                if (data) {
                    const msg = Array.isArray(data) ? (data[0]?.message || '') : (data.message || '');
                    setResponseMessage(msg);
                    setEmployeeAttendanceData(data);
                    setSelectedEmployeeData(data);
                    setCurrentView('employeeDetails');
                } else {
                    setEmployeeAttendanceData(null);
                }
            } else {
                const data = await gettingAttendaceEmployeeWiseNotInTheLocation(
                    state,
                    district,
                    fromDate,
                    toDate,
                    zoneId
                );

                const msg = Array.isArray(data) ? (data[0]?.message || '') : (data?.message || '');
                setResponseMessage(msg);

                if (data?.dailyData) {
                    setAttendanceData(
                        data.dailyData.filter(
                            entry => entry && Object.keys(entry).length > 0
                        )
                    );
                } else if (Array.isArray(data)) {
                    const list = Array.isArray(data[0]?.data) ? data[0].data : data;
                    setAttendanceData(list.filter(entry => entry && Object.keys(entry).length > 0));
                } else {
                    setAttendanceData([]);
                }
            }
        } catch (error) {
            console.error("Error fetching report data:", error);
            setAttendanceData([]);
            setEmployeeAttendanceData(null);
        } finally {
            setIsLoading(false);
        }
    };

    const handleStateDrilldown = async (row) => {
        if (!row?.stateId || !row?.date) {
            return;
        }

        if (state && district) {
            try {
                setCurrentView('drilldown');
                setShowDrilldown(true);
                setShowDistrictSummary(false);
                setIsDrilldownLoading(true);
                setDrilldownData([]);
                setSelectedDate(row.date);
                setSelectedDistrictData(row);

                const responseData = await gettingAttendaceEmployeeWiseNotInTheLocationEmployeePhoto(
                    state,
                    district,
                    row.date,
                    row.date,
                    zoneId
                );

                const msg = Array.isArray(responseData) ? (responseData[0]?.message || '') : (responseData?.message || '');
                setResponseMessage(msg);

                let employeesList = [];
                if (Array.isArray(responseData) && responseData.length > 0) {
                    if (Array.isArray(responseData[0]?.data)) {
                        employeesList = responseData[0].data;
                    } else {
                        employeesList = responseData;
                    }
                } else if (responseData?.data && Array.isArray(responseData.data)) {
                    employeesList = responseData.data;
                }

                let totalCount = 0;
                const processedData = employeesList.filter(
                    employee => employee && Object.keys(employee).length > 0
                );

                processedData.forEach(employee => {
                    if (employee.attendance && employee.attendance.length > 0) {
                        totalCount += employee.attendance.length;
                    }
                });

                setTotalEmployeeCount(totalCount);
                setDrilldownData(processedData);
            } catch (error) {
                console.error("Error fetching employee details:", error);
                setDrilldownData([]);
                setTotalEmployeeCount(0);
            } finally {
                setIsDrilldownLoading(false);
            }
        } else {
            try {
                setCurrentView('districtSummary');
                setShowDistrictSummary(true);
                setShowDrilldown(false);
                setIsDistrictSummaryLoading(true);
                setDistrictSummaryData([]);
                setSelectedState(row);
                setSelectedStateData(row);

                const responseData = await gettingAttendanceDistrictViolationsSummary(
                    row.stateId,
                    row.date,
                    row.date,
                    zoneId
                );

                const msg = Array.isArray(responseData) ? (responseData[0]?.message || '') : (responseData?.message || '');
                setResponseMessage(msg);

                let summaryList = [];
                if (Array.isArray(responseData) && responseData.length > 0) {
                    summaryList = Array.isArray(responseData[0]?.data)
                        ? responseData[0].data
                        : responseData;
                } else if (responseData?.data && Array.isArray(responseData.data)) {
                    summaryList = responseData.data;
                }

                setDistrictSummaryData(
                    summaryList.filter(
                        item => item && Object.keys(item).length > 0
                    )
                );
            } catch (error) {
                console.error("Error fetching district summary:", error);
                setDistrictSummaryData([]);
            } finally {
                setIsDistrictSummaryLoading(false);
            }
        }
    };

    const handleDrilldown = async (row) => {
        if (!row?.date || !row?.stateId || !row?.districtId) {
            return;
        }

        try {
            setCurrentView('drilldown');
            setShowDrilldown(true);
            setShowDistrictSummary(false);
            setIsDrilldownLoading(true);
            setDrilldownData([]);
            setSelectedDate(row.date);
            setSelectedDistrictData(row);

            const districtId = district || row.districtId;
            const stateId = state || row.stateId;

            const responseData = await gettingAttendaceEmployeeWiseNotInTheLocationEmployeePhoto(
                stateId,
                districtId,
                row.date,
                row.date,
                zoneId
            );

            const msg = Array.isArray(responseData) ? (responseData[0]?.message || '') : (responseData?.message || '');
            setResponseMessage(msg);

            let employeesList = [];
            if (Array.isArray(responseData) && responseData.length > 0) {
                if (Array.isArray(responseData[0]?.data)) {
                    employeesList = responseData[0].data;
                } else {
                    employeesList = responseData;
                }
            } else if (responseData?.data && Array.isArray(responseData.data)) {
                employeesList = responseData.data;
            }

            let totalCount = 0;
            const processedData = employeesList.filter(
                employee => employee && Object.keys(employee).length > 0
            );

            processedData.forEach(employee => {
                if (employee.attendance && employee.attendance.length > 0) {
                    totalCount += employee.attendance.length;
                }
            });

            setTotalEmployeeCount(totalCount);
            setDrilldownData(processedData);
        } catch (error) {
            console.error("Error fetching drilldown data:", error);
            setDrilldownData([]);
            setTotalEmployeeCount(0);
        } finally {
            setIsDrilldownLoading(false);
        }
    };

    const handleBackToMainTable = () => {
        setCurrentView('main');
        setShowDrilldown(false);
        setShowDistrictSummary(false);
        setIsDrilldownLoading(false);
        setIsDistrictSummaryLoading(false);
        setDrilldownData([]);
        setDistrictSummaryData([]);
        setSelectedDate(null);
        setSelectedState(null);
        setSelectedStateData(null);
        setSelectedDistrictData(null);
        setTotalEmployeeCount(0);
        setSelectedEmployeeData(null);
        setEmployeeAttendanceData(null);
    };

    const handleBackToDistrictSummary = () => {
        if (state && district) {
            setCurrentView('main');
            setShowDrilldown(false);
            setShowDistrictSummary(false);
            setIsDrilldownLoading(false);
            setIsDistrictSummaryLoading(false);
            setDrilldownData([]);
            setDistrictSummaryData([]);
            setSelectedDate(null);
            setSelectedState(null);
            setSelectedStateData(null);
            setSelectedDistrictData(null);
            setTotalEmployeeCount(0);
            setSelectedEmployeeData(null);
            setEmployeeAttendanceData(null);
        } else {
            setCurrentView('districtSummary');
            setShowDrilldown(false);
            setShowDistrictSummary(true);
            setIsDrilldownLoading(false);
            setDrilldownData([]);
            setSelectedDate(null);
            setSelectedDistrictData(null);
            setTotalEmployeeCount(0);
        }
    };

    // ==================== PDF EXPORT FUNCTION (Using Response Message) ====================
    const exportToPDF = (tableData, headers, title, fileName) => {
        if (!tableData || tableData.length === 0) {
            alert('No data available to export');
            return;
        }

        const doc = new jsPDF('landscape', 'mm', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const reportTime = getReportTime();

        doc.setFontSize(15);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(12, 92, 108);
        doc.text(title, pageWidth / 2, 13, { align: 'center' });

        doc.setFontSize(9.5);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(70, 70, 70);

        // Display response message if available
        const filterHeaderInfo = responseMessage && responseMessage.trim() !== ''
            ? responseMessage
            : 'No filter details available';

        const filterLines = doc.splitTextToSize(filterHeaderInfo, pageWidth - 20);
        let currentY = 19;
        filterLines.forEach((line) => {
            doc.text(line, pageWidth / 2, currentY, { align: 'center' });
            currentY += 4.5;
        });

        doc.setFontSize(8.5);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(100, 100, 100);
        doc.text(`Report Generated: ${reportTime}`, pageWidth - 10, currentY + 1, { align: 'right' });

        const tableRows = tableData.map(row => {
            return headers.map(header => {
                let value = row[header.key];
                if (header.key === 'attendanceDate' && value) {
                    return format(new Date(value), 'dd-MM-yyyy');
                }
                if (header.key === 'date' && value) {
                    return format(new Date(value), 'dd-MM-yyyy');
                }
                if (header.key === 'attendanceTime' && value) {
                    return convertToIST(row.attendanceDate, value);
                }
                if (header.key === 'workLocation') {
                    return value || '-';
                }
                if (typeof value === 'number') return value;
                return value || '-';
            });
        });

        doc.autoTable({
            startY: currentY + 5,
            head: [headers.map(h => h.label)],
            body: tableRows,
            theme: 'grid',
            styles: {
                fontSize: 8.5,
                cellPadding: 2.2,
                valign: 'middle',
                halign: 'center',
                lineColor: [200, 200, 200],
                lineWidth: 0.1
            },
            headStyles: {
                fillColor: [12, 92, 108],
                textColor: [255, 255, 255],
                fontSize: 9,
                fontStyle: 'bold',
                halign: 'center',
                cellPadding: 2.8
            },
            alternateRowStyles: {
                fillColor: [245, 248, 250]
            },
            margin: { left: 8, right: 8, bottom: 12 },
            didDrawPage: (data) => {
                const pageCount = doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                doc.setTextColor(150, 150, 150);
                doc.text(
                    `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
                    pageWidth - 15,
                    doc.internal.pageSize.getHeight() - 5,
                    { align: 'right' }
                );
            }
        });

        doc.save(`${fileName}.pdf`);
    };

    // ==================== EXCEL EXPORT FUNCTION (Using Response Message) ====================
    const exportToExcel = async (tableData, headers, title, fileName) => {
        if (!tableData || tableData.length === 0) {
            alert('No data available to export');
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Report');
        const reportTime = getReportTime();
        const totalCols = headers.length;

        // Title Row
        worksheet.mergeCells(1, 1, 1, totalCols);
        const titleCell = worksheet.getCell(1, 1);
        titleCell.value = title;
        titleCell.font = { size: 16, bold: true, color: { argb: 'FF0C5C6C' } };
        titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getRow(1).height = 30;

        // Response Message Row
        worksheet.mergeCells(2, 1, 2, totalCols);
        const filterCell = worksheet.getCell(2, 1);
        filterCell.value = responseMessage && responseMessage.trim() !== '' ? responseMessage : 'No filter details available';
        filterCell.font = { size: 10, italic: true, color: { argb: 'FF555555' } };
        filterCell.alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getRow(2).height = 22;

        // Report Time Row
        worksheet.mergeCells(3, 1, 3, totalCols);
        const timeCell = worksheet.getCell(3, 1);
        timeCell.value = `Report Generated: ${reportTime}`;
        timeCell.font = { size: 9, italic: true, color: { argb: 'FF777777' } };
        timeCell.alignment = { horizontal: 'right', vertical: 'middle' };
        worksheet.getRow(3).height = 20;

        worksheet.addRow([]);

        // Table Header Row
        const headerRow = worksheet.addRow(headers.map(h => h.label));
        headerRow.height = 26;
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF0C5C6C' }
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = {
                top: { style: 'thin', color: { argb: 'FFB0BEC5' } },
                left: { style: 'thin', color: { argb: 'FFB0BEC5' } },
                bottom: { style: 'thin', color: { argb: 'FFB0BEC5' } },
                right: { style: 'thin', color: { argb: 'FFB0BEC5' } }
            };
        });

        // Data Rows
        tableData.forEach((row, rowIndex) => {
            const rowData = headers.map(header => {
                let value = row[header.key];
                if (header.key === 'attendanceDate' && value) {
                    return format(new Date(value), 'dd-MM-yyyy');
                }
                if (header.key === 'date' && value) {
                    return format(new Date(value), 'dd-MM-yyyy');
                }
                if (header.key === 'attendanceTime' && value) {
                    return convertToIST(row.attendanceDate, value);
                }
                if (header.key === 'workLocation') {
                    return value || '-';
                }
                if (typeof value === 'number') return value;
                return value || '-';
            });

            const addedRow = worksheet.addRow(rowData);
            addedRow.height = 22;

            addedRow.eachCell((cell) => {
                cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                cell.font = { size: 9 };
                if (rowIndex % 2 === 1) {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF5F8FA' }
                    };
                }
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                    left: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                    bottom: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                    right: { style: 'thin', color: { argb: 'FFE0E0E0' } }
                };
            });
        });

        worksheet.columns.forEach((column, colIndex) => {
            let maxLength = headers[colIndex]?.label?.length || 10;
            column.eachCell({ includeEmpty: false }, (cell, rowNumber) => {
                if (rowNumber > 4) {
                    const cellLen = cell.value ? cell.value.toString().length : 0;
                    if (cellLen > maxLength) maxLength = cellLen;
                }
            });
            column.width = Math.min(Math.max(maxLength + 8, 16), 45);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `${fileName}.xlsx`);
    };

    // ==================== EXPORT HANDLERS ====================
    const handleMainTableExport = (type) => {
        if (!attendanceData || attendanceData.length === 0) {
            alert('No data available to export');
            return;
        }

        const headers = [
            { key: 'sno', label: 'S.No' },
            { key: 'date', label: 'Attendance Date' },
            { key: 'above500MeterCount', label: 'Above 500 Meter Count' }
        ];

        const data = attendanceData.map((row, index) => ({
            ...row,
            sno: index + 1
        }));

        const title = 'Employee Not In The Location (500 Meters Away)';
        const fileName = `State_Summary_${format(new Date(), 'dd-MM-yyyy')}`;

        if (type === 'pdf') {
            exportToPDF(data, headers, title, fileName);
        } else {
            exportToExcel(data, headers, title, fileName);
        }
    };

    const handleEmployeeExport = (type) => {
        if (!employeeAttendanceData || !employeeAttendanceData.attendance || employeeAttendanceData.attendance.length === 0) {
            alert('No data available to export');
            return;
        }

        const headers = [
            { key: 'sno', label: 'S.No' },
            { key: 'attendanceDate', label: 'Date' },
            { key: 'status', label: 'Status' },
            { key: 'attendanceTime', label: 'Attendance Time' },
            { key: 'workLocation', label: 'Work Location' },
            { key: 'locationStatus', label: 'Location Status' },
            { key: 'auditRemarks', label: 'Remarks' },
            { key: 'distanceReason', label: 'Distance Reason' }
        ];

        const data = employeeAttendanceData.attendance.map((row, index) => ({
            ...row,
            sno: index + 1,
            workLocation: getWorkLocation(row),
            locationStatus: 'Not In the Location',
            auditRemarks: row.auditRemarks?.length > 0 ? row.auditRemarks.join(', ') : 'No Remarks'
        }));

        const title = `Employee Not In Location Attendance (500 Meters Away) - ${employeeAttendanceData.employeeName || 'Employee'}`;
        const fileName = `Employee_NotInLocation_Attendance_${format(new Date(), 'dd-MM-yyyy')}`;

        if (type === 'pdf') {
            exportToPDF(data, headers, title, fileName);
        } else {
            exportToExcel(data, headers, title, fileName);
        }
    };

    const handleDistrictSummaryExport = (type) => {
        if (!districtSummaryData || districtSummaryData.length === 0) {
            alert('No data available to export');
            return;
        }

        const headers = [
            { key: 'sno', label: 'S.No' },
            { key: 'date', label: 'Date' },
            { key: 'districtName', label: 'District Name' },
            { key: 'violationCount', label: 'Violation Count' }
        ];

        const data = districtSummaryData.map((row, index) => ({
            ...row,
            sno: index + 1
        }));

        const title = `District Violation Summary - ${selectedStateData?.stateName || 'State'}`;
        const fileName = `District_Summary_${format(new Date(), 'dd-MM-yyyy')}`;

        if (type === 'pdf') {
            exportToPDF(data, headers, title, fileName);
        } else {
            exportToExcel(data, headers, title, fileName);
        }
    };

    const handleDrilldownExport = (type) => {
        if (!drilldownData || drilldownData.length === 0) {
            alert('No data available to export');
            return;
        }

        const headers = [
            { key: 'sno', label: 'S.No' },
            { key: 'districtName', label: 'District Name' },
            { key: 'employeeName', label: 'Employee Name' },
            { key: 'designation', label: 'Designation' },
            { key: 'status', label: 'Attendance Status' },
            { key: 'attendanceTime', label: 'Attendance Time' },
            { key: 'workLocation', label: 'Working Location' },
            { key: 'locationStatus', label: 'Location Status' },
            { key: 'remarks', label: 'Remarks' },
            { key: 'distanceReason', label: 'Distance Reason' }
        ];

        const flattenedData = [];
        drilldownData.forEach(emp => {
            const attendance = emp.attendance || [];
            attendance.forEach(row => {
                flattenedData.push({
                    districtName: emp.districtName || '-',
                    employeeName: emp.employeeName || '-',
                    designation: emp.designation || '-',
                    status: row.status || '-',
                    attendanceDate: row.attendanceDate,
                    attendanceTime: row.attendanceTime,
                    workLocation: getWorkLocation(row),
                    locationStatus: 'Not In the Location',
                    remarks: row.auditRemarks?.length > 0 ? row.auditRemarks.join(', ') : 'No Remarks',
                    distanceReason: row.distanceReason
                });
            });
        });

        const dataWithSno = flattenedData.map((row, index) => ({
            ...row,
            sno: index + 1
        }));

        const title = `Attendance Details - ${selectedDate ? format(new Date(selectedDate), 'dd-MM-yyyy') : 'Date'}`;
        const fileName = `Attendance_Details_${format(new Date(), 'dd-MM-yyyy')}`;

        if (type === 'pdf') {
            exportToPDF(dataWithSno, headers, title, fileName);
        } else {
            exportToExcel(dataWithSno, headers, title, fileName);
        }
    };

    // ==================== RENDER EMPLOYEE DETAILS TABLE ====================
    const renderEmployeeDetails = () => {
        if (!employeeAttendanceData || !employeeAttendanceData.attendance) return null;

        const { employeeName, designation, employeeUniqueId, stateName, districtName, contactNumber, attendance } = employeeAttendanceData;

        return (
            <div className="employee-report-not-in-loc-monthlt-att-container">
                <div className="employee-report-not-in-loc-table-header">
                    <h3>
                        Employee Not In Location Attendance Details
                        <span style={{ fontSize: '14px', fontWeight: 'normal', marginLeft: '10px' }}>
                            {employeeName} ({employeeUniqueId}) - {designation}
                        </span>
                    </h3>
                    <div className="employee-report-not-in-loc-export-buttons">
                        <button
                            className="employee-report-not-in-loc-export-btn-pdf-btn"
                            onClick={() => handleEmployeeExport('pdf')}
                            disabled={!attendance || attendance.length === 0}
                        >
                            Download PDF
                        </button>
                        <button
                            className="employee-report-not-in-loc-export-btn-excel-btn"
                            onClick={() => handleEmployeeExport('excel')}
                            disabled={!attendance || attendance.length === 0}
                        >
                            Download Excel
                        </button>
                        <button
                            type="button"
                            className="employee-report-not-in-loc-drilldown-close"
                            onClick={handleBackToMainTable}
                        >
                            ← Back
                        </button>
                    </div>
                </div>

                <div className="employee-summary-cards" style={{ display: 'flex', gap: '20px', padding: '15px', background: '#f8f9fa', borderRadius: '8px', marginBottom: '15px', flexWrap: 'wrap' }}>
                    <div><strong>State:</strong> {stateName || '-'}</div>
                    <div><strong>District:</strong> {districtName || '-'}</div>
                    <div><strong>Contact:</strong> {contactNumber || '-'}</div>
                </div>

                <table className="employee-report-not-in-loc-monthlt-att" ref={employeeTableRef}>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Attendance Time</th>
                            <th>Work Location</th>
                            <th>Location Status</th>
                            <th>Remarks</th>
                            <th>Distance Reason</th>
                            <th>Photo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="9" className="table-status-message">
                                    <div className="table-loader-spinner"></div>
                                    Loading employee attendance...
                                </td>
                            </tr>
                        ) : attendance && attendance.length > 0 ? (
                            attendance.map((row, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        {row.attendanceDate
                                            ? format(new Date(row.attendanceDate), "dd-MM-yyyy")
                                            : "-"}
                                    </td>
                                    <td>{row.status || "-"}</td>
                                    <td>
                                        {row.attendanceTime
                                            ? convertToIST(row.attendanceDate, row.attendanceTime)
                                            : "-"}
                                    </td>
                                    <td>{getWorkLocation(row)}</td>
                                    <td>Not In the Location</td>
                                    <td>
                                        {row.auditRemarks?.length > 0
                                            ? row.auditRemarks.join(", ")
                                            : "No Remarks"}
                                    </td>
                                    <td>{capitalizeFirstLetter(row.distanceReason) || "-"}</td>
                                    <td>
                                        {row.selfieUrl ? (
                                            <a href={row.selfieUrl} target="_blank" rel="noreferrer">
                                                View Photo
                                            </a>
                                        ) : (
                                            "No Photo"
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="table-status-message">
                                    No attendance data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className="employee-report-not-in-loc-container">
            <div className="employee-report-not-in-loc-box">
                <h2 className="employee-report-not-in-loc-heading">Employee Not In Location Report (500 Meters Away)</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="employee-report-not-in-loc-maincontainer">
                        <div className="employee-report-not-in-loc-container-part">
                            <div className={`employee-report-not-in-loc-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable={!isITM}
                                    isDisabled={isITM}
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="employee-report-not-in-loc-container-part">
                            <div className={`employee-report-not-in-loc-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable={!isITM}
                                    isDisabled={isITM}
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>Working District</label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="employee-report-not-in-loc-maincontainer">
                        <div className="employee-report-not-in-loc-container-part">
                            <div className={`employee-report-not-in-loc-floating-label-container ${isFocused.employee || employee ? 'float-label' : ''}`}>
                                <Select
                                    name='employee'
                                    options={employeeOptions}
                                    value={employeeOptions.find(opt => opt.value === employee) || null}
                                    onChange={option => handleInputChange(option, 'employee')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, employee: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, employee: false }))}
                                    placeholder=" "
                                    isClearable={!district}
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>Employee</label>
                            </div>
                        </div>
                        <div className="employee-report-not-in-loc-container-part">
                            <div className={`employee-report-not-in-loc-floating-label-container ${isFocused.fromDate || fromDate ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={fromDate}
                                    onChange={(date) => setFromDate(date)}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, fromDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, fromDate: false }))}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText=""
                                    className="employee-report-not-in-loc-date-picker"
                                    maxDate={new Date()}
                                    ref={yearInputRef}
                                />
                                <label><span className="required">*</span>From Date</label>
                            </div>
                        </div>
                    </div>
                    <div className="employee-report-not-in-loc-maincontainer">
                        <div className="employee-report-not-in-loc-container-part">
                            <div className={`employee-report-not-in-loc-floating-label-container ${isFocused.toDate || toDate ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={toDate}
                                    onChange={(date) => setToDate(date)}
                                    dateFormat='dd-MM-yyyy'
                                    className="employee-report-not-in-loc-date-picker"
                                    minDate={fromDate}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, toDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, toDate: false }))}
                                />
                                <label><span className="required">*</span>To Date</label>
                            </div>
                        </div>
                        <div className="employee-report-not-in-loc-container-part">
                            <div className="employee-report-not-in-loc-btn-div" style={{ display: 'flex', gap: '10px' }}>
                                <button
                                    type="submit"
                                    className="employee-report-not-in-loc-btn"
                                    disabled={!isFetchDataEnabled}
                                >
                                    Generate Report
                                </button>
                                <button
                                    type="button"
                                    className="employee-report-not-in-loc-clear-btn"
                                    onClick={handleClearAll}
                                    style={{
                                        padding: '8px 20px',
                                        background: '#dc3545',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'background 0.3s'
                                    }}
                                >
                                    Clear All
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            {currentView === 'employeeDetails' ? (
                renderEmployeeDetails()
            ) : currentView === 'main' ? (
                <div className="employee-report-not-in-loc-monthlt-att-container">
                    <div className="employee-report-not-in-loc-table-header">
                        <h3>
                            State wise Summary
                            {state && (
                                <span>
                                    - {stateOptions.find(opt => opt.value === state)?.label || ''}
                                    {/* {zoneName && (
                                        <span>
                                            {' - '}
                                            {zoneName}
                                        </span>
                                    )} */}
                                    {district && (
                                        <span>
                                            {' - '}
                                            {districtOptions.find(opt => opt.value === district)?.label || ''}
                                        </span>
                                    )}
                                </span>
                            )}
                        </h3>
                        <div className="employee-report-not-in-loc-export-buttons">
                            <button
                                className="employee-report-not-in-loc-export-btn-pdf-btn"
                                onClick={() => handleMainTableExport('pdf')}
                                disabled={!attendanceData || attendanceData.length === 0}
                            >
                                Download PDF
                            </button>
                            <button
                                className="employee-report-not-in-loc-export-btn-excel-btn"
                                onClick={() => handleMainTableExport('excel')}
                                disabled={!attendanceData || attendanceData.length === 0}
                            >
                                Download Excel
                            </button>
                        </div>
                    </div>
                    <table className="employee-report-not-in-loc-monthlt-att" ref={mainTableRef}>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Attendance Date</th>
                                <th>Above 500 Meter Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="3" className="table-status-message">
                                        <div className="table-loader-spinner"></div>
                                        Loading attendance summary...
                                    </td>
                                </tr>
                            ) : attendanceData.length > 0 ? (
                                attendanceData.map((row, index) => (
                                    <tr
                                        key={index}
                                        onClick={() => handleStateDrilldown(row)}
                                        className="drilldown-clickable-row"
                                    >
                                        <td>{index + 1}</td>
                                        <td>
                                            {row.date
                                                ? format(
                                                    new Date(row.date),
                                                    "dd-MM-yyyy"
                                                )
                                                : "-"}
                                        </td>
                                        <td>{row.above500MeterCount ?? 0}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="3"
                                        className="table-status-message"
                                    >
                                        {hasFetched
                                            ? "No attendance data available"
                                            : "Select filters and click 'Generate Report'"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            ) : currentView === 'districtSummary' ? (
                <div className="employee-report-not-in-loc-monthlt-att-container">
                    <div className="employee-report-not-in-loc-drilldown-header">
                        <h3>
                            District wise Summary
                            {selectedStateData?.stateName && (
                                <span>
                                    {" - "}
                                    {selectedStateData.stateName}
                                </span>
                            )}
                        </h3>
                        <div className="employee-report-not-in-loc-export-buttons">
                            <button
                                className="employee-report-not-in-loc-export-btn-pdf-btn"
                                onClick={() => handleDistrictSummaryExport('pdf')}
                                disabled={!districtSummaryData || districtSummaryData.length === 0}
                            >
                                Download PDF
                            </button>
                            <button
                                className="employee-report-not-in-loc-export-btn-excel-btn"
                                onClick={() => handleDistrictSummaryExport('excel')}
                                disabled={!districtSummaryData || districtSummaryData.length === 0}
                            >
                                Download Excel
                            </button>
                            <button
                                type="button"
                                className="employee-report-not-in-loc-drilldown-close"
                                onClick={handleBackToMainTable}
                            >
                                ← Back to Main
                            </button>
                        </div>
                    </div>
                    <table className="employee-report-not-in-loc-monthlt-att" ref={districtSummaryTableRef}>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Date</th>
                                <th>District Name</th>
                                <th>Violation Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isDistrictSummaryLoading ? (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="table-status-message"
                                    >
                                        <div className="table-loader-spinner"></div>
                                        Loading district summary...
                                    </td>
                                </tr>
                            ) : districtSummaryData.length > 0 ? (
                                districtSummaryData.map((row, index) => (
                                    <tr
                                        key={`${row.districtId}-${row.date}`}
                                        onClick={() => handleDrilldown(row)}
                                        className="drilldown-clickable-row"
                                    >
                                        <td>{index + 1}</td>
                                        <td>
                                            {row.date
                                                ? format(
                                                    new Date(row.date),
                                                    "dd-MM-yyyy"
                                                )
                                                : "-"}
                                        </td>
                                        <td>{row.districtName || "-"}</td>
                                        <td>{row.violationCount ?? 0}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="table-status-message"
                                    >
                                        No district violation data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="employee-report-not-in-loc-drilldown-container">
                    <div className="employee-report-not-in-loc-drilldown-header">
                        <h3>
                            Attendance Details
                            {selectedDate && (
                                <span>
                                    {" - "}
                                    {format(
                                        new Date(selectedDate),
                                        "dd-MM-yyyy"
                                    )}
                                </span>
                            )}
                            {selectedDistrictData?.districtName && (
                                <span>
                                    {" - "}
                                    {selectedDistrictData.districtName}
                                </span>
                            )}
                        </h3>
                        <div className="employee-report-not-in-loc-export-buttons">
                            <button
                                className="employee-report-not-in-loc-export-btn-pdf-btn"
                                onClick={() => handleDrilldownExport('pdf')}
                                disabled={!drilldownData || drilldownData.length === 0}
                            >
                                Download PDF
                            </button>
                            <button
                                className="employee-report-not-in-loc-export-btn-excel-btn"
                                onClick={() => handleDrilldownExport('excel')}
                                disabled={!drilldownData || drilldownData.length === 0}
                            >
                                Download Excel
                            </button>
                            <button
                                type="button"
                                className="employee-report-not-in-loc-drilldown-close"
                                onClick={handleBackToDistrictSummary}
                            >
                                {state && district ? '← Back to Main' : '← Back to District Summary'}
                            </button>
                        </div>
                    </div>
                    <div className='count-direction'>
                        <p>
                            <span className="employee-report-not-in-loc-total-count">
                                Total Employees: {totalEmployeeCount}
                            </span>
                        </p>
                    </div>

                    <div className="report-table-monthlt-att-container-count">
                        <table className="report-table-monthlt-att" ref={drilldownTableRef}>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>District Name</th>
                                    <th>Employee Name</th>
                                    <th>Designation</th>
                                    <th>Attendance Status</th>
                                    <th>Attendance Time</th>
                                    <th>Working Location</th>
                                    <th>Location Status</th>
                                    <th>Remarks</th>
                                    <th>Distance Reason</th>
                                    <th>Attendance Photo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isDrilldownLoading ? (
                                    <tr>
                                        <td
                                            colSpan="11"
                                            className="table-status-message"
                                        >
                                            <div className="table-loader-spinner"></div>
                                            Loading attendance details...
                                        </td>
                                    </tr>
                                ) : drilldownData.length > 0 ? (
                                    drilldownData.flatMap(
                                        (emp, employeeIndex) => {
                                            const attendance = emp.attendance || [];

                                            return attendance.map(
                                                (row, attendanceIndex) => (
                                                    <tr
                                                        key={`${emp.employeeUniqueId}-${attendanceIndex}`}
                                                    >
                                                        <td>{employeeIndex + 1}</td>
                                                        <td>{emp.districtName || "-"}</td>
                                                        <td>{emp.employeeName || "-"}</td>
                                                        <td>{emp.designation || "-"}</td>
                                                        <td>{row.status || "-"}</td>
                                                        <td>
                                                            {row.attendanceTime
                                                                ? convertToIST(
                                                                    row.attendanceDate,
                                                                    row.attendanceTime
                                                                )
                                                                : "-"}
                                                        </td>
                                                        <td>{getWorkLocation(row)}</td>
                                                        <td>Not in the location</td>
                                                        <td>
                                                            {row.auditRemarks?.length > 0
                                                                ? row.auditRemarks.join(", ")
                                                                : "No Remarks"}
                                                        </td>
                                                        <td>{capitalizeFirstLetter(row.distanceReason) || "-"}</td>
                                                        <td>
                                                            {row.selfieUrl ? (
                                                                <a
                                                                    href={row.selfieUrl}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    View Photo
                                                                </a>
                                                            ) : (
                                                                "No Photo"
                                                            )}
                                                        </td>
                                                    </tr>
                                                )
                                            );
                                        }
                                    )
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="11"
                                            className="table-status-message"
                                        >
                                            No attendance details available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotInTheLocationAttendanceReport;